export const ParameterErrorCode = {
  API_000400: '입력값이 잘못되었습니다.',
  API_000404: '리소스를 찾을 수 없습니다.',
  API_001001: '유효한 provider 이름이 아닙니다.',
  API_001002: '잘못된 요청 입니다.',
  API_001400: '잘못된 파라미터 오류 입니다.',
  API_001401: '인증이 되지 않았습니다.',
  API_001402: '블락된 유저 입니다.',
  API_001409: '중복 되었습니다.',
  API_001404: '인증 정보를 찾을 수 없습니다.',
  API_002400: '잘못된 파라미터 오류 입니다.',
  API_002404: '유저를 찾을 수 없습니다.',
  API_003409: '사용중인 주소입니다.',
  API_003404: '지갑을 찾을 수 없습니다.',
  API_004404: '입금 계좌를 찾을 수 없습니다.',
  API_004460: '금액이 충분하지 않습니다.',
  API_005404: '출금 계좌를 찾을 수 없습니다.',
  API_006404: 'QnA를 찾을 수 없습니다.',
  API_010404: '해당 작품을 찾을 수 없습니다.',
  API_011404: '해당 판매를 찾을 수 없습니다.',
  API_011460: '판매 상태가 아닙니다.',
  API_011461: '남은 판매 갯수가 충분하지 않습니다.',
  API_012409: '이미 매각 투표를 진행 했습니다.',
  API_012404: '해당 매각 투표 정보를 찾을 수 없습니다.',
  API_012601: '매각투표를 진행할 수 없습니다.',
  API_012602: '매각투표 기간이 아닙니다.',
  API_013001: '거래 가능 상태가 아닙니다.',
  API_014404: '거래 주문을 찾을 수 없습니다.',
  API_014460: '잔여 수량이 충분하지 않습니다.',
  API_015404: '해당 댓글을 찾을 수 없습니다.',
  API_015405: '이미 신고 되엇습니다.',
  API_015406: '신고 유형이 잘못 되었습니다.',
  API_015407: '신고 대상이 잘못 되었습니다.',
  API_020404: '해당 알림을 찾을 수 없습니다.',
  // API_030404: '해당 리소스를 찾을 수 없습니다.',
  API_030404: '삭제된 글입니다.',
  // API_031404: '해당 리소스를 찾을 수 없습니다.',
  API_031404: '삭제된 글입니다.',
  API_041001: '예치금이 충분하지 않습니다.',
  API_042400: '트랜잭션 파라미터 오류',
  API_043001: '수익금 지급 가능 상태가 아닙니다.',
  API_043002: '가지고 있는 토큰이 충분하지 않습니다.',
  API_044400: '파라미터가 잘못 되었습니다.',
  API_044404: '해당 리소스를 찾을 수 없습니다.',
  API_050404: '해당 리소스를 찾을 수 없습니다.',
} as const

export const ServerErrorCode = {
  API_000001: '시스템 오류',
  API_001001: '카카오 웹 토큰 정보 조회 실패',
  API_001002: '카카오 웹 유저 정보 조회 실패',
  API_001003: '네이버 웹 토큰 정보 조회 실패',
  API_001004: '네이버 웹 유저 정보 조회 실패',
  API_001005: '구글 토큰 검증 실패',
  API_001006: '잘못된 구글 웹 토큰 정보',
  API_001007: '구글 웹 유저 정보 조회 실패',
  API_003015: '지갑 전송 오류',
  API_044001: '알려지지 않은 오류',
  API_044006: '구매 계약서 다운로드 오류',
  API_044007: '토큰 회수 오류',
  API_044008: 'PDF 생성 오류',
  UTIL_001001: '알 수 없는 DB 오류',
  UTIL_001002: 'DB insert 오류',
  UTIL_001003: 'DB update 오류',
  UTIL_001004: 'DB 조회 오류',
  UTIL_001005: 'DB delete 오류',
  UTIL_002001: '컨트랙트 전송 실패',
  UTIL_002002: 'Transaction Hash가 존재하지 않음',
  UTIL_002003: '인증 이미지 업로드 실패',
} as const

export const isParameterError = (code: string): code is keyof typeof ParameterErrorCode =>
  code != null && code in ParameterErrorCode

export const isServerError = (code: string): code is keyof typeof ServerErrorCode =>
  code != null && code in ServerErrorCode

export const getParamErrorMessage = (code: string) => {
  return isParameterError(code) && String(ParameterErrorCode[code])
}

export const getServerErrorMessage = (code: string) => {
  return isServerError(code) && String(ServerErrorCode[code])
}
